import axios from "axios";
import store from "@/store";
import Echo from 'laravel-echo';
import { removeAPIPrefix } from "../../utils/url";

let coursesServiceInstance = null
const coursesReverb = () => coursesServiceInstance
const subdomain = window.location.host.split('.')[0]
const addressAPIWithoutPrefix = removeAPIPrefix(process?.env?.VUE_APP_ARANDU_COURSES_URL)
export const baseUrl = process?.env?.VUE_APP_APPLICATION_SECURITY + subdomain + '.' + process?.env?.VUE_APP_ARANDU_COURSES_URL
const reverbBaseURL = process?.env?.VUE_APP_APPLICATION_SECURITY + subdomain + '.' + addressAPIWithoutPrefix
const reverbSecretKey = process?.env?.VUE_APP_COURSES_API_REVERB_KEY
const shouldInitializeReverb = Boolean(!coursesServiceInstance && addressAPIWithoutPrefix && subdomain && reverbSecretKey)

const CoursesApiService = axios.create({
    baseURL: baseUrl,
    headers: {
        "Content-type": "application/json",
        Accept: "application/json",
    },
});

CoursesApiService.interceptors.request.use(
    (config) => {
        if (config?.data instanceof FormData) {
            delete config.headers['Content-type']
            delete config.headers['Content-Type']
        }

        const token = store.getters.getToken;

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },

    (error) => {
        return Promise.reject(error);
    }
);

const initializeCoursesReverb = (userToken) => {
    if (shouldInitializeReverb && userToken) {
        const reverbWsConnection = () => {
            if (process?.env?.VUE_APP !== 'localhost') {
              return `${subdomain}.${addressAPIWithoutPrefix}`
          }
        
        return 'localhost'
        }

        try {
            coursesServiceInstance = new Echo({
                broadcaster: 'reverb',
                  key: reverbSecretKey,
                  wsHost: reverbWsConnection(),
                  wsPort: process?.env?.VUE_APP === 'localhost' ? 6005 : 80,
                  wssPort: process?.env?.VUE_APP === 'localhost' ? 6005 : 443,
                  forceTLS: window.location.protocol === 'https',
                  path: '/app',
                  enabledTransports: ['ws', 'wss'],
                  authEndpoint: `${reverbBaseURL}/broadcasting/auth`,
                  auth: {
                      headers: {
                          Authorization: 'Bearer ' + userToken,
                      },
                  }
              })
        } catch (error) {
            console.error(error)
        }
    }
}

const leaveCoursesReverbPrivateChannel = (channelName) => {
    if (coursesServiceInstance && channelName) {
        coursesServiceInstance.leave(`private-${channelName}`)
    }
}

const verifyCoursesServiceReverb = (consumerId) => {
    if (coursesServiceInstance) {
        let connected = false
        try {
            coursesReverb().private(`App.Models.User.${consumerId}`)
            connected = true
        }
        catch (error) {
            console.error("Courses WS: ", error)
        } finally {
            if (connected) {
                setTimeout(() => {
                    coursesReverb().leave(`App.Models.User.${consumerId}`)
                }, 1000)
            }
        }
    }
}

export {
    initializeCoursesReverb,
    verifyCoursesServiceReverb,
    leaveCoursesReverbPrivateChannel,
    coursesReverb
}

export default CoursesApiService;
